import styled from 'styled-components';
export const Wrapper = styled.li ``;
export const Button = styled.button `
  background-color: var(--stepped-quiz-btn);
  border-radius: var(--border-radius-sm);
  padding: 1.5rem;
  width: 15rem;
  border: none;
  cursor: pointer;
  transition: background-color 200ms linear;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  height: 100%;
  min-height: 6.8rem;

  &:hover {
    background-color: var(--stepped-quiz-btn-hover);
  }
  
  span {
    color: white;
    margin-bottom: 0;
    font-weight: 600;
  }
  
  svg {
    fill: white;
    width: 5rem;
    height: 5rem;
  }
`;
export default {
    Wrapper,
    Button,
};
